import React from 'react';
import AutoRefillSwitch from './AutoRefillSwitch';
import AutoRefillSetting from './AutoRefillSetting';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  autoRefillMessageContainer: {
    padding: theme.spacing(0, 3),
  },
  autoRefillMessage: {
    margin: '15px 0 5px 0',
  },
  error: {
    fontSize: 14,
    color: theme.palette.error.main,
    padding: theme.spacing(0, 0, 0.5, 3),
  },
}));

interface Props {
  enabledAutoRefill: boolean;
  failedCard: string;
  autoRefillAmount?: number;
  changeAutoRefillAmount?: (e: any) => void;
  setEnabledAutoRefill: (enabled: boolean) => void;
}

const AutoRefillTab = ({
  enabledAutoRefill,
  failedCard,
  autoRefillAmount,
  changeAutoRefillAmount,
  setEnabledAutoRefill,
}: Props) => {
  const classes = useStyles();

  return (
    <>
      {enabledAutoRefill && failedCard && (
        <div className={classes.error}>
          We were unable to charge the card ending in {failedCard}. Please check with card issuer or
          use another payment method.
        </div>
      )}
      <AutoRefillSwitch
        checked={enabledAutoRefill}
        onChange={(e) => setEnabledAutoRefill(e.target.checked)}
      />
      {enabledAutoRefill ? (
        <AutoRefillSetting
          autoRefillAmount={autoRefillAmount}
          changeAutoRefillAmount={changeAutoRefillAmount}
        />
      ) : (
        <div className={classes.autoRefillMessageContainer}>
          <Typography variant="body2" color="textSecondary" className={classes.autoRefillMessage}>
            Auto-refill automatically funds account once your balance drops below your chosen
            threshold.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Please toggle the switch above to enable Auto-refill or press Single Payment tab above
            to fund your account
          </Typography>
        </div>
      )}
    </>
  );
};

export default AutoRefillTab;
